
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import Head from "next/head";
import Link from "next/link";
import { FaPuzzlePiece } from "react-icons/fa";
import PageShell from "@/components/layout/PageShell";
import PageHeader from "@/components/layout/PageHeader";
import PuzzleBreadcrumbs from "@/modules/puzzles/PuzzleBreadcrumbs";
import CategoryTrainer from "@/modules/puzzles/CategoryTrainer";
import { getPuzzleCategory, localizePuzzleCategory, puzzleCategories, } from "@/modules/puzzles/catalog";
import useTranslation from "next-translate/useTranslation";
export default function PuzzleCategory({ slug }: {
    slug: string;
}) {
    const { t } = useTranslation("puzzles");
    const category = localizePuzzleCategory(getPuzzleCategory(slug)!, t);
    return (<PageShell compactMobile>
      <Head>
        <title>
          {t("themes.freePracticeTitle", { title: category.title })}
        </title>
        <meta name="description" content={category.description}/>
      </Head>
      <div className="hidden md:block">
        <PuzzleBreadcrumbs includeHome={false} title={category.short} path={`/puzzles/${slug}`} parent={{ name: t("themes.title"), path: "/puzzles/themes" }}/>
      </div>
      <PageHeader title={<>
            <span className="md:hidden">{category.short}</span>
            <span className="hidden md:inline">{category.title}</span>
          </>} description={category.description} fullWidthDescription icon={FaPuzzlePiece} compactMobile/>
      <CategoryTrainer key={slug} theme={category.theme}/>
      <section className="mt-10 border-t border-athens-gray-200 pt-8">
        <h2 className="text-base font-semibold text-slate-600">
          {t("themes.keepPracticing")}
        </h2>
        <div className="mt-4 flex flex-wrap gap-3">
          {puzzleCategories
            .filter((item) => item.slug !== slug)
            .map((item) => (<Link key={item.slug} href={`/puzzles/${item.slug}`} className="rounded border border-athens-gray-200 bg-white px-4 py-3 text-sm font-semibold text-altblue-700 transition-colors hover:bg-slate-100 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary">
                {t(`themes.categories.${item.slug}.short`)}
              </Link>))}
        </div>
        <p className="mt-5 text-base text-slate-600">
          {t("themes.tryDailyBefore")}{" "}
          <Link href="/puzzle" className="text-altblue-700 underline">
            {t("themes.dailyLink")}
          </Link>
          , {t("themes.or")}{" "}
          <Link href="/play" className="text-altblue-700 underline">
            {t("themes.playGameLink")}
          </Link>{" "}
          {t("themes.tryDailyAfter")}
        </p>
        <Link href="/puzzles" className="mt-5 inline-flex items-center gap-1 text-sm font-semibold text-altblue-700 hover:underline">
          {t("nav.league")} <span aria-hidden="true">→</span>
        </Link>
      </section>
    </PageShell>);
}
export async function getStaticPaths({ locales = ["en"] }) {
    return {
        paths: locales.flatMap((locale) => puzzleCategories.map(({ slug }) => ({
            params: { category: slug },
            locale,
        }))),
        fallback: false,
    };
}
async function getStaticProps({ params }) {
    return getPuzzleCategory(params.category)
        ? { props: { slug: params.category } }
        : { notFound: true };
}

    async function __Next_Translate__getStaticProps__1a0fc0d5598__(ctx) {
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/puzzles/[category]',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a0fc0d5598__ as getStaticProps }
  